import { render, staticRenderFns } from "./appstore1.vue?vue&type=template&id=d96a5ab2&"
import script from "./appstore1.vue?vue&type=script&lang=js&"
export * from "./appstore1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports